import { Smartphone } from 'lucide-react';
import GenericHeader from '@/components/ui/GenericHeader';
import SendAnimatedIcon from '@/components/ui/SendAnimatedIcon';
import UndoAnimatedIcon from '@/components/ui/UndoAnimatedIcon';
import { copyDoAviso, linkDoApp } from './copy';
import './AvisoOutroCanal.css';

export type AvisoOutroCanalVariante = 'rota' | 'drawer';

export interface AvisoOutroCanalConteudoProps {
  recurso: string;
  variante: AvisoOutroCanalVariante;
  /** Record the app should open; without it the link opens the app's start screen. */
  registroId?: string | null;
  /** Route only: secondary way back, since the route no longer resets home. */
  onVoltarAoInicio?: () => void;
}

/**
 * Hand-off body of the "available in the Joshua app" notice (JOSH-91,
 * option "Passagem"). The way into the app comes first; going back is the
 * secondary exit. It never reads as a permission denial.
 */
export function AvisoOutroCanalConteudo({
  recurso,
  variante,
  registroId,
  onVoltarAoInicio,
}: AvisoOutroCanalConteudoProps) {
  const copy = copyDoAviso(recurso);
  const link = linkDoApp(recurso, registroId);
  const naRota = variante === 'rota';

  return (
    <div
      className={`ac-aviso-canal ac-aviso-canal--${variante}`}
      data-testid="aviso-outro-canal"
    >
      <span className="ac-aviso-canal__kicker">
        <Smartphone size={13} aria-hidden="true" />
        No app Joshua
      </span>
      <h2 className="ac-aviso-canal__titulo">{naRota ? copy.tituloRota : copy.tituloDrawer}</h2>
      {naRota && <p className="ac-aviso-canal__texto">{copy.texto}</p>}

      <div className="ac-aviso-canal__passagem">
        <a className="btn-add send-animated ac-aviso-canal__abrir" href={link}>
          <SendAnimatedIcon size={15} /> <span className="btn-text">Abrir no app Joshua</span>
        </a>
        <span className="ac-aviso-canal__onde">{copy.ondeNoApp}</span>
      </div>

      {naRota && onVoltarAoInicio && (
        <div className="ac-aviso-canal__acoes">
          <button type="button" className="btn-add undo-animated" onClick={onVoltarAoInicio}>
            <UndoAnimatedIcon size={15} /> <span className="btn-text">Voltar ao Início</span>
          </button>
        </div>
      )}
    </div>
  );
}

export interface AvisoOutroCanalRotaProps {
  recurso: string;
  onVoltarAoInicio?: () => void;
}

/** Route notice: the page header plus the hand-off card, in place of the view. */
export default function AvisoOutroCanalRota({ recurso, onVoltarAoInicio }: AvisoOutroCanalRotaProps) {
  const copy = copyDoAviso(recurso);
  return (
    <div className="page-shell">
      <GenericHeader mode="list" title={copy.rotuloRota} showSearch={false} canAdd={false} />
      <div className="ac-card ac-aviso-canal__card">
        <AvisoOutroCanalConteudo
          recurso={recurso}
          variante="rota"
          onVoltarAoInicio={onVoltarAoInicio}
        />
      </div>
    </div>
  );
}
